/* Vote for Re-release — the one vote pop-up for retired products.
 * Task: https://app.clickup.com/t/14zcqnthubz  (approved mockups on 14zcqnthuc0)
 *
 * WHY OUR OWN POP-UP
 * The vote used to open Klaviyo's back-in-stock modal. That modal cannot be
 * restyled to the mockup, cannot hold its button off until an email is typed,
 * and on collection pages Klaviyo only attaches it to sold-out products, so a
 * retired product that still had stock got no way to vote at all.
 *
 * WHERE A VOTE GOES
 * Still Klaviyo's back-in-stock list, through its public client endpoint, so
 * the merchandising team keeps reading demand in the one place they already
 * use. Only the account's public key is involved; nothing secret is on the page.
 *
 * WHO OPENS IT
 * Any element with [data-retired-vote]:
 *   - the collection card button    (snippets/product-retired-card-cta.liquid)
 *   - the retired product page      (snippets/product-retired-cta.liquid)
 *   - retired cards in search       (decorated below, since the Searchanise app
 *                                     draws those and we do not own the markup)
 * The trigger carries the product title and a variant id when Liquid knows
 * them; a search card only knows its link, so the product is looked up by
 * handle on click.
 *
 * AFTER A VOTE
 * The pop-up says "Your vote is in!" (collection mockup). A trigger marked
 * data-vote-success="banner" closes it instead and shows a green line in place
 * of the button (product page mockup).
 */
(function () {
    'use strict';

    var dialog = document.getElementById('RetiredVoteDialog');
    if (!dialog || typeof dialog.showModal !== 'function') return;

    var ACCOUNT = dialog.dataset.account || '';
    var REVISION = '2024-10-15';
    var ENDPOINT = 'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(ACCOUNT);

    var form = dialog.querySelector('[data-vote-form]');
    var input = dialog.querySelector('[data-vote-email]');
    var submit = dialog.querySelector('[data-vote-submit]');
    var error = dialog.querySelector('[data-vote-error]');
    var askView = dialog.querySelector('[data-vote-ask]');
    var doneView = dialog.querySelector('[data-vote-done]');
    var titleEls = dialog.querySelectorAll('[data-vote-product]');
    var emailEl = dialog.querySelector('[data-vote-done-email]');

    var current = null; // { trigger, title, variantId, handle }

    function syncSubmit() {
        submit.disabled = !input.value.trim() || submit.dataset.busy === 'true';
    }

    function setTitle(title) {
        titleEls.forEach(function (el) { el.textContent = title; });
    }

    function open(trigger) {
        current = {
            trigger: trigger,
            title: trigger.dataset.productTitle || '',
            variantId: trigger.dataset.variantId || '',
            handle: trigger.dataset.productHandle || ''
        };
        setTitle(current.title);
        askView.hidden = false;
        doneView.hidden = true;
        error.textContent = '';
        input.value = '';
        submit.dataset.busy = 'false';
        syncSubmit();
        dialog.showModal();
        input.focus();

        // A search card knows only its link. Fill in the name straight away so
        // the heading is right before anyone types.
        if (!current.variantId && current.handle) {
            lookup(current).catch(function () {});
        }
    }

    function close() {
        dialog.close();
    }

    function lookup(vote) {
        return fetch('/products/' + encodeURIComponent(vote.handle) + '.js', { credentials: 'same-origin' })
            .then(function (r) {
                if (!r.ok) throw new Error('product ' + r.status);
                return r.json();
            })
            .then(function (p) {
                var v = (p.variants || [])[0];
                vote.variantId = v ? String(v.id) : '';
                if (!vote.title) {
                    vote.title = p.title || '';
                    if (vote === current) setTitle(vote.title);
                }
                return vote;
            });
    }

    // On a product page the shopper may have picked a variant; vote on that one.
    function variantFor(vote) {
        if (vote.trigger.dataset.voteSuccess === 'banner') {
            var picked = document.querySelector('form[action*="/cart/add"] [name="id"]');
            if (picked && picked.value) return picked.value;
        }
        return vote.variantId;
    }

    function send(email, variantId) {
        return fetch(ENDPOINT, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/vnd.api+json',
                'Accept': 'application/vnd.api+json',
                'revision': REVISION
            },
            body: JSON.stringify({
                data: {
                    type: 'back-in-stock-subscription',
                    attributes: {
                        channels: ['EMAIL'],
                        profile: { data: { type: 'profile', attributes: { email: email } } }
                    },
                    relationships: {
                        variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId } }
                    }
                }
            })
        }).then(function (r) {
            if (!r.ok) throw new Error('klaviyo ' + r.status);
        });
    }

    function done(vote, email) {
        if (vote.trigger.dataset.voteSuccess === 'banner') {
            close();
            var holder = vote.trigger.closest('[data-retired-cta]');
            var banner = holder && holder.querySelector('[data-vote-banner]');
            if (banner) {
                vote.trigger.hidden = true;
                banner.hidden = false;
                var dismiss = banner.querySelector('[data-vote-banner-close]');
                if (dismiss) dismiss.focus();
            }
            return;
        }
        emailEl.textContent = email;
        askView.hidden = true;
        doneView.hidden = false;
        var keep = doneView.querySelector('[data-vote-close]');
        if (keep) keep.focus();
    }

    // Capture phase: a search card's button sits inside the app's product link,
    // and the vote must win over the navigation.
    document.addEventListener('click', function (e) {
        var trigger = e.target.closest('[data-retired-vote]');
        if (trigger) {
            e.preventDefault();
            e.stopPropagation();
            open(trigger);
            return;
        }
        var dismiss = e.target.closest('[data-vote-banner-close]');
        if (dismiss) {
            e.preventDefault();
            var holder = dismiss.closest('[data-retired-cta]');
            var btn = holder && holder.querySelector('[data-retired-vote]');
            dismiss.closest('[data-vote-banner]').hidden = true;
            if (btn) {
                btn.hidden = false;
                btn.focus();
            }
        }
    }, true);

    input.addEventListener('input', function () {
        error.textContent = '';
        syncSubmit();
    });

    // A click on the dim backdrop lands on the dialog itself, not its panel.
    dialog.addEventListener('click', function (e) {
        if (e.target === dialog) close();
    });

    dialog.querySelectorAll('[data-vote-close]').forEach(function (b) {
        b.addEventListener('click', close);
    });

    dialog.addEventListener('close', function () {
        if (current && current.trigger && !current.trigger.hidden) current.trigger.focus();
    });

    form.addEventListener('submit', function (e) {
        e.preventDefault();
        var vote = current;
        var email = input.value.trim();
        if (!vote || !email) return;
        if (!input.checkValidity()) {
            error.textContent = dialog.dataset.errorEmail || 'Please enter a valid email address.';
            input.focus();
            return;
        }

        submit.dataset.busy = 'true';
        syncSubmit();

        var ready = vote.variantId || !vote.handle ? Promise.resolve(vote) : lookup(vote);
        ready
            .then(function (v) {
                var id = variantFor(v);
                if (!id || !ACCOUNT) throw new Error('missing variant or account');
                return send(email, id);
            })
            .then(function () {
                if (vote === current) done(vote, email);
            })
            .catch(function () {
                error.textContent = dialog.dataset.errorSend || 'Sorry, your vote did not go through. Please try again.';
            })
            .then(function () {
                submit.dataset.busy = 'false';
                syncSubmit();
            });
    });

    /* ------------------------------------------------------------------
       Retired cards in Searchanise results. The app tags each card with
       snize-product-tag-<tag>, so the retired tag from theme settings finds
       them. The card gets the RETIRED badge and its button becomes the vote
       button; the price, sale labels, stock line and wishlist heart are hidden
       in assets/searchanise-results.css. The app re-renders on every page,
       sort and filter change, so this re-runs whenever the list changes.
       ------------------------------------------------------------------ */
    var TAG = (dialog.dataset.retiredTag || 'retired').toLowerCase().trim().replace(/[^a-z0-9]+/g, '-');
    var CARD = 'li.snize-product.snize-product-tag-' + TAG;
    var BADGE = dialog.dataset.badgeLabel || 'Retired';
    var CTA = dialog.dataset.ctaLabel || 'Vote for Re-release!';

    function decorate(root) {
        root.querySelectorAll(CARD + ':not([data-retired-card])').forEach(function (li) {
            li.setAttribute('data-retired-card', '');
            li.classList.add('retired-search-card');

            var link = li.querySelector('a.snize-view-link');
            var match = link && (link.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
            var title = li.querySelector('.snize-title');

            var thumb = li.querySelector('.snize-thumbnail-wrapper');
            if (thumb) {
                var badge = document.createElement('span');
                badge.className = 'retired-search-card__badge';
                badge.textContent = BADGE;
                thumb.appendChild(badge);
            }

            var old = li.querySelector('.snize-buttons .snize-button');
            if (old && match) {
                var btn = document.createElement('button');
                btn.type = 'button';
                // Keeps the app's own button classes, so it lands in the same spot
                // and shape; searchanise-results.css only recolours it.
                btn.className = old.className + ' retired-vote-btn retired-search-card__cta';
                btn.classList.remove('snize-view-product-button', 'snize-add-to-cart-button');
                btn.textContent = CTA;
                btn.setAttribute('data-retired-vote', '');
                btn.setAttribute('aria-haspopup', 'dialog');
                btn.dataset.productHandle = decodeURIComponent(match[1]);
                if (title) btn.dataset.productTitle = title.textContent.trim();
                old.replaceWith(btn);
            }
        });
    }

    // Watch the page, not #snize_results: the widget swaps that element for a
    // new one once its results arrive, which leaves an observer on the old node
    // watching nothing. One pass per frame, however many nodes changed.
    if (document.getElementById('snize_results') || /search-results-page/.test(location.pathname)) {
        var queued = false;
        var run = function () {
            queued = false;
            decorate(document);
        };
        run();
        new MutationObserver(function () {
            if (queued) return;
            queued = true;
            requestAnimationFrame(run);
        }).observe(document.body, { childList: true, subtree: true });
    }
})();
